<template>
  <div>
    <top-message />
    <div class="bottomPart">
      <div class="titlePart">客户推荐</div>
      <el-form
        :inline="true"
        :model="searchForm"
        class="demo-form-inline"
        style="padding: 20px 30px 0"
      >
        <el-form-item label="企业名称">
          <el-input
            v-model="searchForm.enterpriseName"
            placeholder="请输入"
            style="width: 120px"
            suffix-icon="el-icon-search"
            @change="handleChangeSearch"
          />
        </el-form-item>
        <el-form-item label="推荐开始日期">
          <div class="block">
            <!-- <el-date-picker
              style="width: 200px"
              v-model="searchForm.timeRange"
              @change="handleTimeChange"
              type="monthrange"
              range-separator="至"
              start-placeholder="开始"
              end-placeholder="结束"
            >
            </el-date-picker>-->
            <el-date-picker
              :editable="false"
              v-model="searchForm.startTime"
              :picker-options="startDatePicker"
              type="month"
              value-format="yyyy-MM"
              format="yyyy-MM"
              placeholder="选择开始日期"
              @change="handleTimeChange"
            />
          </div>
        </el-form-item>
        <el-form-item label="结束时间" prop="endTime">
          <el-date-picker
            :editable="false"
            v-model="searchForm.endTime"
            :picker-options="endDatePicker"
            type="month"
            value-format="yyyy-MM"
            format="yyyy-MM"
            placeholder="选择结束日期"
            @change="handleTimeChange"
          />
        </el-form-item>
        <el-form-item label="需求金额">
          <el-select
            v-model="searchForm.moneyRange"
            placeholder="请选择"
            style="width: 120px"
            clearable
            @change="handleMoneyChange"
          >
            <el-option
              v-for="item in moneyOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否关注">
          <el-select
            v-model="searchForm.isFollow"
            placeholder="请选择"
            style="width: 120px"
            clearable
            @change="handleChangeisFollow"
          >
            <el-option
              v-for="item in statusOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否授信">
          <el-select
            v-model="searchForm.isCredit"
            placeholder="请选择"
            style="width: 120px"
            clearable
            @change="handleChangeisCredit"
          >
            <el-option
              v-for="item in creditStatus"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否放款">
          <el-select
            v-model="searchForm.isLoan"
            placeholder="请选择"
            style="width: 120px"
            clearable
            @change="handleChangeisLoan"
          >
            <el-option
              v-for="item in lendingStatus"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <!-- <el-form
        :inline="true"
        :model="searchForm"
        class="demo-form-inline"
        style="padding: 20px 30px 0"
      >
     
      </el-form>-->
      <div class="recordPart">
        <div class="top">
          <el-rate :value="1" :colors="colors" :max="1" disabled />
          <div class="title">关注后可查看企业联系方式</div>
        </div>
        <div>
          <el-button type="primary" @click="getApplyList">导出企业清单</el-button>
          <el-button type="primary" @click="showConfirm">批量导入授信/放款信息</el-button>
        </div>
      </div>

      <!-- ================================================= -->
      <el-dialog
        :visible.sync="Confirm"
        width="40%"
        custom-class="class1"
        title="批量导入授信/放款信息"
        :close-on-click-modal="false"
        :destroy-on-close="true"
        :modal-append-to-body="false"
        :lock-scroll="false"
      >
        <div class="top1">
          <img src="../../assets/images/xlsicon.png" alt />
          <div class="son">
            <span>导入模板</span>
            <el-link type="primary" :underline="false" @click="Download">下载</el-link>
          </div>
        </div>
        <div class="bottom1">
          <div class="upload1">
            <span class="upload-text1">
              <span>请点击上传</span>
              <el-upload
                class="upload-demo"
                :action="xslUrl"
                :headers="headers"
                accept=".xlsx, .xls"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :on-change="handChange"
                :auto-upload="uploadStatus"
                ref="uploadFile"
              >
                <el-link
                  type="primary"
                  :underline="false"
                  style="font-size:18px;margin-left:5px;"
                >选择文件</el-link>
              </el-upload>
            </span>

            <span class="upload-btn">* 仅支持上传xls/xlsx文件</span>
            <span>※如需修改上传过的业务数据，请在网页上搜索对应业务进行手动更改。</span>
          </div>
          <div class="sample">
            <img src="@/assets/images/excel.png" alt />
            <div>{{FileName}}</div>
          </div>
        </div>
        <div class="btn1">
          <el-button class="anniu1" @click="ConfirmShow " type="primary">上传</el-button>
        </div>
      </el-dialog>

      <!-- ================================================= -->
      <div class="list" style="padding: 0">
        <el-table :data="tableData" style="width: 100%;">
          <el-table-column label="全选" prop="isFollow" :render-header="renderHeader">
            <template slot-scope="scope">
              <img
                @click="rateStatus(1,scope.row)"
                v-if="scope.row.isFollow == 0"
                src="../../assets/images/noSelect.png"
                alt
              />
              <img v-else src="../../assets/images/Select.png" alt />
              <!-- <el-rate
                void-color='#E0E4E9'
                disabled-void-color='#F85B4B;'
                v-model="scope.row.isFollow"
                :colors="colors"
                :max="1"
                @change='rateStatus'
              />-->
            </template>
          </el-table-column>
          <el-table-column prop="enterpriseName" label="企业名称" width="250" show-overflow-tooltip />
          <el-table-column prop="enterpriseCode" label="统一信用代码" width="180" show-overflow-tooltip />
          <el-table-column label="联系方式" width="120" show-overflow-tooltip>
            <template slot-scope="{ row }">
              <span v-if="row.isFollow==1">{{row.legalPersonPhone}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="需求金额">
            <template slot-scope="{ row }">
              <span>{{ row.loanMinAmount }}-{{ row.loanMaxAmount }}万</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="推荐时间" width="100" />
          <el-table-column label="操作" width="200">
            <template slot-scope="{ row }">
              <el-button type="text" size="small" @click="cli_details(row.bank_id)">信用信息</el-button>
              <el-button
                v-if="row.isFollow ==1"
                type="text"
                size="small"
                @click="handleOpen(row)"
              >授信/放款</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" :total="total" @current-change="currentChange"></el-pagination>
      </div>
      <el-dialog
        :visible.sync="dialogVisible"
        title="授信/放款"
        width="30%"
        custom-class="authDialog"
        :show-close="false"
        :modal-append-to-body="false"
        :lock-scroll="false"
      >
        <div class="info">
          <span style="color: red">*</span>如果拒绝授信，请在授信金额处填“0”
        </div>
        <el-form :inline="true" :model="submitForm" class="demo-form-inline" label-width="80px">
          <el-form-item label="授信时间" prop="authTime">
            <div class="block">
              <el-date-picker
                v-model="submitForm.authTime"
                type="date"
                placeholder="请选择"
                value-format="yyyy-MM-dd"
                :disabled="authstatus"
              ></el-date-picker>
            </div>
          </el-form-item>
          <el-form-item label="授信金额" prop="authMoney">
            <el-input-number
              v-model="submitForm.authMoney"
              :min="0"
              :max="100000000"
              :controls="false"
              :disabled="authstatus"
              placeholder="请输入"
            />
            <el-button class="myMainButton" @click.prevent="handleEdit()">修改</el-button>
          </el-form-item>
          <!-- <el-form-item 
            label="放款时间"
            prop="loanTime"
          >
            <div class="block">
              <el-date-picker
                v-model="submitForm.loans.loanTime"
                type="date"
                placeholder="请选择"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </div>
          </el-form-item>
          <el-form-item
            label="放款金额"
            prop="loanMoney"
          >
            <el-input-number
              v-model="submitForm.loans.loanMoney"
              :min="0"
              :max="100000000"
              :controls="false"
              placeholder="请输入"
            />
            <el-button
              class="myMainButton"
              @click.prevent="handleEdit()"
            >修改</el-button>
          </el-form-item>-->
          <div v-for="(item, index) in submitForm.loans" :key="index">
            <el-form-item label="放款时间" :prop="'loans.' + index + '.loanTime'">
              <div class="block">
                <el-date-picker
                  v-model="item.loanTime"
                  type="date"
                  placeholder="请选择"
                  value-format="yyyy-MM-dd"
                  :disabled="item.status"
                ></el-date-picker>
              </div>
            </el-form-item>
            <el-form-item label="放款金额" :prop="'loans.' + index + '.loanAmount'">
              <el-input-number
                v-model="item.loanAmount"
                :disabled="item.status"
                :min="0"
                :max="100000000"
                :controls="false"
                placeholder="请输入"
              />
              <el-button
                class="myMainButton"
                v-if="item.appId !== null&&item.appId!==''"
                @click="loanStatus(index)"
              >修改</el-button>
              <el-button class="myButton" @click.prevent="handleRemove(item)" v-else>删除</el-button>
            </el-form-item>
          </div>
        </el-form>
        <div class="buttonList">
          <el-button class="myButton" @click="handshow()">取消</el-button>
          <el-button type="primary" class="myPrimaryButton" @click="submitEnter">确认</el-button>
          <el-button
            type="primary"
            class="myPrimaryButton"
            icon="el-icon-plus"
            @click="(submitForm.authMoney>0)?handleAdd():''"
          >新增放款</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  JgList,
  followApply,
  bathFollow,
  expertLoanDetailById
} from "@/api/statistics";
import TopMessage from "@/components/TopMessage";
import utils from "@/utils/utils";
import baseUrl from "@/api/baseUrl";
export default {
  components: { TopMessage },
  data() {
    return {
      searchForm: {
        timeRange: [],
        enterpriseName: "",
        startTime: "",
        endTime: "",
        loanMinAmount: "",
        loanMaxAmount: "",
        isFollow: "",
        isLoan: "",
        isCredit: "",
        moneyRange: ""
      },
      tableData: [],
      selectList: [],
      moneyOption: [
        { value: 1, label: "100万以下" },
        { value: 2, label: "100万以上" }
        // { value: 3, label: "100-200万" },
        // { value: 4, label: "200-500万" },
        // { value: 5, label: "500万以上" },
      ],
      statusOption: [
        { value: 0, label: "否" },
        { value: 1, label: "是" }
      ],
      creditStatus: [
        { value: 0, label: "否" },
        { value: 1, label: "是" }
      ],
      lendingStatus: [
        { value: 0, label: "否" },
        { value: 1, label: "是" }
      ],
      colors: ["#E0E4E9", "#E0E4E9", "#F85B4B"],
      dialogVisible: false,
      submitForm: {
        authTime: "",
        authMoney: undefined,
        loans: []
      },
      Confirm: false,
      value: "",
      xslUrl: baseUrl + "/api/credit/import/importApplyList",
      headers: {
        token: sessionStorage.getItem("token")
      },
      params: {
        type: 6
      },
      size: 1,
      pageSize: 10,
      total: 0,
      appId: "",
      id: "",
      status: "",
      uploadStatus: false,
      creditInfoId: "",
      authstatus: false,
      FileName: "",
      startDatePicker: this.beginDate(),
      endDatePicker: this.processDate()
    };
  },
  created() {
    this.getList();
  },
  methods: {
    beginDate() {
      const self = this;
      return {
        disabledDate(time) {
          if (self.searchForm.endTime) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.searchForm.endTime).getTime() < time.getTime();
          } else {
            // return time.getTime() > Date.now()//开始时间不选时，结束时间最大值小于等于当天
          }
        }
      };
    },
    processDate() {
      const self = this;
      return {
        disabledDate(time) {
          if (self.searchForm.startTime) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.searchForm.startTime).getTime() > time.getTime()
            );
          } else {
            // return time.getTime() > Date.now()//开始时间不选时，结束时间最大值小于等于当天
          }
        }
      };
    },
    handChange(res) {
      this.FileName = res.name;
    },
    Download() {
      const xhr = new XMLHttpRequest();
      xhr.open("get", this.baseUrl + "/api/v1/file/downApplyExcel", true); // get、post都可
      xhr.responseType = "blob"; // 转换流
      xhr.setRequestHeader("token", sessionStorage.getItem("token")); // token键值对
      xhr.onload = function() {
        if (this.status === 200) {
          const blob = this.response;
          const fileName = "当月授信放款信息模板.xlsx";
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            const a = document.createElement("a");
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
          }
        }
      };
      xhr.send();
    },
    submitEnter() {
      let params = {
        appId: this.appId,
        id: this.id,
        status: this.status,
        operateType: "credit",
        creditInfo: {
          creditTime: this.submitForm.authTime,
          creditAmount: this.submitForm.authMoney,
          id: this.creditInfoId
        },
        loanInfoList: this.submitForm.loans
      };
      followApply(this.sendParam(params))
        .then(res => {
          res = this.paramDecrypt(res);
          if (res.code == 200) {
            this.$message.success(res.msg);
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(error => {});
      this.dialogVisible = false;
      this.authstatus = true;
    },
    handshow() {
      this.dialogVisible = false;
      this.authstatus = true;
    },
    ConfirmShow() {
      // this.uploadStatus = true
      this.$refs.uploadFile.submit();
      this.Confirm = false;
    },
    cli_details(id) {
      this.$router.push({
        path: "/xyd/creditDetails",
        query: {
          keyword: id
        }
      });
    },
    getApplyList() {
      const xhr = new XMLHttpRequest();
      xhr.open(
        "post",
        this.baseUrl + "/api/credit/excel/expertCompanyApplyList",
        true
      ); // get、post都可
      xhr.responseType = "blob"; // 转换流
      xhr.setRequestHeader("token", sessionStorage.getItem("token")); // token键值对
      xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
      xhr.onload = function() {
        if (this.status === 200) {
          const blob = this.response;
          const fileName = "企业清单.xls";
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            const a = document.createElement("a");
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
          }
        }
      };
      xhr.send(
        "appDeptName=" +
          this.searchForm.enterpriseName +
          "&startTime=" +
          this.searchForm.startTime +
          "&endTime=" +
          this.searchForm.endTime +
          "&loanMinAmount=" +
          this.searchForm.loanMinAmount +
          "&loanMaxAmount=" +
          this.searchForm.loanMaxAmount +
          "&isFollow=" +
          this.searchForm.isFollow +
          "&isCredit=" +
          this.searchForm.isCredit +
          "&isLoan=" +
          this.searchForm.isLoan +
          "&page=" +
          this.size +
          "&pageSize=" +
          this.pageSize
      );
    },
    getList() {
      const params = {
        appDeptName: this.searchForm.enterpriseName,
        startTime: this.searchForm.startTime,
        endTime: this.searchForm.endTime,
        loanMinAmount: this.searchForm.loanMinAmount,
        loanMaxAmount: this.searchForm.loanMaxAmount,
        isFollow: this.searchForm.isFollow,
        isCredit: this.searchForm.isCredit,
        isLoan: this.searchForm.isLoan,
        page: this.size,
        pageSize: this.pageSize
      };
      JgList(this.sendParam(params))
        .then(res => {
          res = this.paramDecrypt(res);
          if (res.code == 200) {
            // 请求成功后赋值
            this.tableData = res.data;
            this.total = res.pageInfo.total;
          }
        })
        .catch(error => {});
    },
    handleChangeisFollow(e) {
      this.searchForm.isFollow = e;
      this.getList();
    },
    handleChangeisCredit(e) {
      this.searchForm.isCredit = e;
      this.getList();
    },
    handleChangeisLoan(e) {
      this.searchForm.isLoan = e;
      this.getList();
    },
    handleChangeSearch(e) {
      this.searchForm.enterpriseName = e;
      this.getList();
    },
    getRecommend() {
      this.Confirm = false;
    },
    // 申请时间范围
    handleTimeChange(timeRange) {
      // this.searchForm.startTime = timeRange && timeRange.length ? this.$moment(timeRange[0]).format("YYYY-MM") : "";
      // this.searchForm.endTime = timeRange && timeRange.length ? this.$moment(timeRange[1]).format("YYYY-MM") : "";
      this.getList();
    },
    // 需求金额范围
    handleMoneyChange(i) {
      switch (i) {
        case 1:
          this.searchForm.loanMinAmount = 0;
          this.searchForm.loanMaxAmount = 100;
          break;
        case 2:
          this.searchForm.loanMinAmount = 100;
          this.searchForm.loanMaxAmount = undefined;
          break;
        // case 3:
        //   this.searchForm.loanMinAmount = 100;
        //   this.searchForm.loanMaxAmount = 200;
        //   break;
        // case 4:
        //   this.searchForm.loanMinAmount = 200;
        //   this.searchForm.loanMaxAmount = 500;
        //   break;
        // case 5:
        //   this.searchForm.loanMinAmount = 500;
        //   this.searchForm.loanMaxAmount = undefined;
        //   break;
        default:
          this.searchForm.loanMinAmount = undefined;
          this.searchForm.loanMaxAmount = undefined;
      }
      this.getList();
    },
    handleOpen(e) {
      this.getById(e.id);
      this.dialogVisible = true;
      this.id = e.id;
      this.appId = e.appId;
      this.status = e.status;
    },
    loanStatus(id) {
      this.submitForm.loans[id].status = false;
    },
    getById(e) {
      let params = {
        id: e
      };
      expertLoanDetailById(this.sendParam(params))
        .then(res => {
          res = this.paramDecrypt(res);
          if (res.code == 200) {
            console.log(res, "rrr");

            let creatTime = utils.timestampToTimeLong(
              res.data.creditInfo.creditTime
            );
            this.submitForm.authTime = creatTime;
            this.creditInfoId = res.data.creditInfo.id;
            this.submitForm.authMoney = res.data.creditInfo.creditAmount;
            res.data.loanInfoList.forEach(item => {
              item.loanTime = utils.timestampToTimeLong(item.loanTime);
              this.$set(item, "status", true);
            });
            if (res.data.loanInfoList.length == 0) {
              let obj = {
                appId: "",
                loanTime: "",
                loanAmount: undefined
              };
              this.submitForm.loans.push(obj);
            }
            this.submitForm.loans = res.data.loanInfoList;
          }
        })
        .catch(error => {});
    },
    handleAdd() {
      this.submitForm.loans.push({
        appId: "",
        loanTime: "",
        loanAmount: undefined
      });
    },
    handleRemove(item) {
      const index = this.submitForm.loans.indexOf(item);
      if (index !== -1) {
        this.submitForm.loans.splice(index, 1);
      }
    },
    currentChange(e) {
      this.size = e;
      this.getList();
    },
    handleEdit() {
      this.authstatus = false;
    },
    showConfirm() {
      this.Confirm = true;
      this.FileName = "";
    },
    handleAvatarSuccess(res) {
      if (res.code == 200) {
        this.FileName = "";
        this.$message.success(res.msg);
        this.getList();
      } else if (res.code == 202) {
        this.$message.error(res.msg);
        this.FileName = "";
        this.getList();
      }
    },
    rateStatus(e, val) {
      let stat = "";
      if (e == 1) {
        stat = "follow";
      }
      let params = {
        id: val.id,
        appId: val.appId,
        status: val.status,
        operateType: stat
      };
      followApply(this.sendParam(params))
        .then(res => {
          res = this.paramDecrypt(res);
          this.getList();
        })
        .catch(error => {});

      // if (e == 1) {
      //   e = 0
      // } else if (e == 0) {
      //   e = 1
      // }
    },
    handerClick() {
      let obj = this.tableData;
      let listarry = [];
      obj.forEach(item => {
        // let arr = {}
        // arr.id = item.id
        listarry.push(item.id);
        return listarry;
      });
      this.selectList = listarry;
      let params = this.selectList;
      bathFollow(this.sendParam(params))
        .then(res => {
          res = this.paramDecrypt(res);
          if (res.code == 200) {
            this.getList();
          } else {
            this.getList();
            this.$message.error(res.msg);
          }
        })
        .catch(res => {});
    },
    renderHeader() {
      return (
        <span onClick={this.handerClick} class="span">
          {" "}
          <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAAAAXNSR0IArs4c6QAAAedJREFUOE+llL+LE0EUx7/fWU9EUNzNsUn2jGIwrXD/gfirsNBKDpQDCxUEwc5GrLxOuEa0EvzBVXYWlmKllZzCiWWuyGUzN8nsKqhHkMzTJHgmXrK50yln3vvMe/N93yG2sUREkXSTQjkpoHsea3uFU3hbzOU+ZcVPhIkIGyb9COBNlA+u/RdMN5vnnFMvAGyg0z4URVFrHHBiZbFJXkPkeA9AuROF0wv/BKubdJbiljeTCd1pfy+XSqWNUcCxlYmI1zDpU0AuDSaSvFEMgwcjYf0ke55QRwUoA3JEyLKCHBbB1JiWvgFcFaBKSlU5teqULPcqWzPpZSXuEQBvO6OyNYZWyNObbcbr6TzgHu8cyKYjzxwM/Q9Dbxbr5CIoz3YANEp4qlAIVnpi/11y3dg5CpYA7MpsmdD0cHLQFSPVjNeTh4Bcz5x2Yq4Y5p4PKT0qITb2JQRns63DW8V8cG8irG7sGgUz2cpyKcoH85mwWq0WeLv32iEQWQUkgODAn32uRPngWCZM69YJR77qexGfKVhIWvq+7/v74e25C0j351Akfnz9kuyrVCrt38AtAmhtbzpikYInnurcDsNQD97e8ytksWt+RzXbna+xsFjbq6LUu5nQf5/1Zg1jL9BJUihM97v4tX4CqBa3/WzMj5cAAAAASUVORK5CYII=" />{" "}
          全选
        </span>
      );
    }
  }
};
</script>

<style lang="less" scoped>
.list {
  min-height: 670px;
}
.span {
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    margin-right: 3px;
  }
}
.bottomPart {
  width: 100%;
  min-height: 680px;
  background: #fff;
  box-sizing: border-box;
  padding-top: 20px;
  font-size: 14px;
  border-radius: 6px;
  margin-top: 20px;
  .titlePart {
    color: #2981ee;
    font-size: 24px;
    font-weight: bold;
    border-left: 6px solid #2981ee;
    padding-left: 20px;
    margin-bottom: 20px;
  }
}
.recordPart {
  height: 66px;
  background: rgba(248, 91, 72, 0.05);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 30px;
  padding-right: 30px;
  .top {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .title {
    color: #f85b4b;
    font-size: 14px;
    margin-left: 5px;
  }
}
.el-rate {
  width: 18px;
  height: 18px;
  opacity: 1;
}
/deep/.el-table {
  thead tr th {
    background: #f3f4f9;
  }
  thead tr th:first-child div {
    padding-left: 30px;
  }
  tbody tr td:first-child > div {
    padding-left: 30px;
  }
}
.el-pagination {
  margin-top: 20px;
  text-align: center;
}
</style>

<style lang="less">
.authDialog {
  width: 730px !important;
  .info {
    margin-bottom: 30px;
  }
  .el-form {
    .el-button {
      margin-left: 10px;
    }
  }
  .buttonList {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
<style lang='less'>
.class1 {
  border-radius: 6px !important;
  padding: 0 !important;
  // background-color: #f1f1f1;
  .el-dialog__header {
    text-align: center;
    font-size: 26px;
    font-family: Alibaba PuHuiTi;
    font-weight: 500;
    color: #000000;
  }
  .el-dialog__body {
    padding: 40px 50px;
  }
  .top1 {
    background-color: #e0efe7 !important;
    height: 76px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    img {
      width: 26px;
      height: 24px;
    }
    .son {
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        margin-left: 5px;
      }
    }
  }
  .bottom1 {
    width: 100%;
    height: 256px;
    margin-top: 40px;
    background-color: #fff;
    border: 1px dashed #d4d4d7;
    padding: 30px;
    box-sizing: border-box;
    .upload1 {
      height: 140px;
      width: 100%;
      border-bottom: 1px solid #dedee0;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      padding: 10px;
      box-sizing: border-box;
      .upload-text1 {
        font-size: 20px;
        font-family: Alibaba PuHuiTi;
        font-weight: 500;
        color: #2a2a2a;
        margin-right: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .upload-btn {
        font-size: 18px;
        font-family: Alibaba PuHuiTi;
        font-weight: 500;
        color: #a2a4ac;
      }
    }
    .sample {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 25px;
      color: #a9acb7;
    }
  }
  .btn1 {
    width: 100%;
    height: 44px;
    margin-top: 20px;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    padding: 0 100px;
    .anniu1 {
      width: 144px;
      height: 100%;
      border-radius: 8px;
    }
  }
}
</style>